import { BiRepost } from "react-icons/bi";
import { BsFilePost } from "react-icons/bs";
import { LuLock, LuQuote } from "react-icons/lu";

import {
  PostCategoryFilter,
  useFeedInternalContext,
} from "@/contexts/feed-context";

import { FeedFilter } from "../feed-filter";
import { UserFeedSortDropdown } from "./feed-sort-dropdown";

const FILTERS = [
  {
    label: "Posts",
    postCategory: PostCategoryFilter.Post,
    icon: BsFilePost,
  },
  {
    label: "Reposts",
    postCategory: PostCategoryFilter.Repost,
    icon: BiRepost,
  },
  {
    label: "Gated Posts",
    postCategory: PostCategoryFilter.GatedPosts,
    icon: LuLock,
  },
  {
    label: "Quoted Reposts",
    postCategory: PostCategoryFilter.QuotedRepost,
    icon: LuQuote,
  },
  {
    label: "Include Replies",
    postCategory: PostCategoryFilter.WithReplies,
    icon: LuQuote,
  },
];

export const UserFeedHeader = () => {
  const { postCategoryFilter, setPostCategoryFilter } =
    useFeedInternalContext();

  return (
    <div className="unforce-radius flex justify-between border-b p-0 text-xs">
      <FeedFilter
        items={FILTERS}
        filter={postCategoryFilter}
        setFilter={setPostCategoryFilter}
      />
      <UserFeedSortDropdown />
    </div>
  );
};
